import { createSlice } from '@reduxjs/toolkit'
import { RootState } from '../store'
import {
  TelemetryGroupByField,
  TelemetryGroupByFieldResponse,
  TelemetryPercentagesResponse,
} from '../../api/awsApis'
import {
  fetchTelemetryGroupedByField,
  fetchTelemetryPercentages,
} from '../actions/analyticsActions'

type State = {
  telemetryField: TelemetryGroupByField | ''
  telemetryResult: TelemetryGroupByFieldResponse | null
  loading: boolean
  error: string | undefined
  percentages: TelemetryPercentagesResponse | null
  percentagesLoading: boolean
  percentagesError: string | undefined
}

const initialState: State = {
  telemetryField: '',
  telemetryResult: null,
  loading: false,
  error: undefined,
  percentages: null,
  percentagesLoading: false,
  percentagesError: undefined,
}

const analyticsSlice = createSlice({
  name: 'analytics_slice',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchTelemetryGroupedByField.pending, (state, action) => {
      state.loading = true
      state.error = undefined
      state.telemetryField = action.meta.arg
    })
    builder.addCase(
      fetchTelemetryGroupedByField.fulfilled,
      (state, action) => {
        state.loading = false
        state.telemetryResult = action.payload
      },
    )
    builder.addCase(
      fetchTelemetryGroupedByField.rejected,
      (state, action) => {
        state.loading = false
        state.error = action.payload || 'Failed to fetch analytics data'
        state.telemetryResult = null
      },
    )
    builder.addCase(fetchTelemetryPercentages.pending, (state) => {
      state.percentagesLoading = true
      state.percentagesError = undefined
    })
    builder.addCase(fetchTelemetryPercentages.fulfilled, (state, action) => {
      state.percentagesLoading = false
      state.percentages = action.payload
    })
    builder.addCase(fetchTelemetryPercentages.rejected, (state, action) => {
      state.percentagesLoading = false
      state.percentagesError =
        action.payload || 'Failed to fetch analytics percentages'
    })
  },
})

export const selectAnalyticsState = (state: RootState) => state.analytics_slice

export default analyticsSlice.reducer
